import gql from "graphql-tag";

export const PrepaidBalancePartsFragmentDoc = gql`
    fragment PrepaidBalanceParts on CurrentUserType {
        hasSubscription
        hasPrepaidBalance
        totalPrepaidBalanceAvailableCents
    }
`;
